import { render } from "./HowToPlay.vue?vue&type=template&id=2a44a82a&scoped=true"
import script from "./HowToPlay.vue?vue&type=script&lang=js"
export * from "./HowToPlay.vue?vue&type=script&lang=js"

import "./HowToPlay.vue?vue&type=style&index=0&id=2a44a82a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a44a82a"]])

export default __exports__